import React from "react";
import classNames from 'classnames';
import withStyles from '@mui/styles/withStyles';

import { toUpperCaseNoAccent } from 'utils/stringHelper';


import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';


import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';


import AddIcon from '@mui/icons-material/AddCircle';
import RemoveIcon from '@mui/icons-material/RemoveCircle';


import Button from '@mui/material/Button';



const styles = theme => ({

    dialogContent: {
        display: 'flex',
        flexDirection: 'column'
    }

});

const AddTransporteurDialog = ({ classes, onClose, onClickSave }) => {

    const [code, setCode] = React.useState('');
    const [nom, setNom] = React.useState('');
    const [type, setType] = React.useState('0');
    const [codes, setCodes] = React.useState(['']);

    const removeCode = (index) => {        
        var newCodes = [...codes];
        newCodes.splice(index, 1);
        setCodes(newCodes);

    };

    const changeCode = (index, value) => {
        var newCodes = [...codes];
        newCodes[index] = value;
        setCodes(newCodes);
    };

    const addCode = () => {
        var newCodes = [...codes, ''];
        setCodes(newCodes);
    };



    const save = () => {

        var transporteur = {
            nom: nom,
            code: code,
            type: type,
            codes: codes
        };

        onClickSave(transporteur);
        onClose();
    };

    return (
        <Dialog open>
            <DialogTitle>Nouveau transporteur</DialogTitle>

            <DialogContent className={classes.dialogContent}>


                <FormControl margin="normal">
                    <FormLabel component="legend" required>Nom</FormLabel>
                    <TextField
                        id="nom"
                        name="nom"
                        placeholder="Saisir un nom"
                        value={nom}
                        onChange={e => setNom(e.target.value)}
                    />
                </FormControl>

                <FormControl margin="normal">
                    <FormLabel component="legend" required>Code</FormLabel>
                    <TextField
                        id="code"
                        name="code"
                        placeholder="Saisir un code"
                        value={code}
                        onChange={e => setCode(toUpperCaseNoAccent(e.target.value))}
                    />
                </FormControl>


                <FormControl margin="normal">
                    <FormLabel component="legend">Type</FormLabel>
                    <RadioGroup
                        aria-label="type"
                        name="type"
                        value={type}
                        onChange={e => setType(e.target.value)}
                        style={{ flexDirection: 'row' }}
                    >
                        <FormControlLabel value="0" control={<Radio />} label="Messager" />
                        <FormControlLabel value="1" control={<Radio />} label="Expressiste" />
                    </RadioGroup>
                </FormControl>



                <FormControl margin="normal">
                    <FormLabel component="legend">Codes transporteur logistique</FormLabel>


                    {codes.map((tl, index) => (
                        <div key={index}>

                            <FormControl margin="normal">
                                <FormLabel component="legend" required>Code {index+1}</FormLabel>
                                <TextField
                                    id={"code" + index}
                                    placeholder="Code"
                                    value={tl.code}
                                    onChange={e => changeCode(index, e.target.value)}
                                />
                            </FormControl>

                            {codes.length > 1 && 
                                <Button variant="contained" size="small" className={classes.button} onClick={(e) => removeCode(index)}>
                                    <RemoveIcon className={classNames(classes.leftIcon, classes.iconSmall)} />
                                    Supprimer
                                </Button>
                            }


                        </div>
                    ))}
                </FormControl>

                <Button variant="contained" size="small" className={classes.button} onClick={(e) => addCode()}>
                    <AddIcon className={classNames(classes.leftIcon, classes.iconSmall)} />
                    Nouveau code
                </Button>

            </DialogContent>

            <DialogActions>
                <Button
                    onClick={onClose}
                    color="primary"
                >
                    Annuler
                </Button>
                <Button
                    onClick={save}
                    variant="contained"
                    color="secondary"
                    disabled={!nom || !code}
                >
                    Enregistrer
                </Button>
            </DialogActions>
        </Dialog>
    );
};


export default withStyles(styles)(AddTransporteurDialog);
